import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import Grid from '@material-ui/core/Grid';
import styled from "styled-components"

function AboutMe() {
  return (
    <StaticQuery
      query={aboutQuery}
      render={data => {
        const { author, social } = data.site.siteMetadata
        return (
          <Container>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={4}>
                <ProfilePic>
            <Image
              fixed={data.avatar.childImageSharp.fixed}
              alt={author}
              objectFit="cover"
              imgStyle={{
                  display: "block"
                //   paddingTop: "40%"
                // maxHeight: 600,
                // maxWidth: 400
              }}
            />
            </ProfilePic>
            </Grid>
            <Grid item xs={12} sm={8}>
            <Intro>
            <h4>
            About Me
            </h4>
            <p>
            My name is Yifang Li, which means “fine inside out”, making it a perfect life-long goal of mine, as I believe we are all a work in progress. 
            </p>
            <p>
            I was born and raised in Shenzhen, a major coastal city and the technology and innovation hub of China. 
            Its vibrant, multicultural environment has shaped me into an open-minded and creative knowledge seeker. 
            I am a graduate of <a href={`http://en.shenzhong.net/`}>Shenzhen Middle School</a> (high school division) and the <a href={`https://www.upenn.edu/`}>University of Pennsylvania</a>, 
            with a BSE degree from <a href={`https://www.seas.upenn.edu/`}>the School of Engineering</a>’s <a href={`http://cg.cis.upenn.edu/dmd.html`}>Digital Media Design</a> program, and a BS degree with 
            concentration in <a href={`https://undergrad-inside.wharton.upenn.edu/maom/`}>Marketing and Operations Operations Management</a> from <a href={`https://www.wharton.upenn.edu/`}>the Wharton School</a>. 
            </p>
            <p>
            I am currently an AI software engineer and consultant at <a href={`https://www.bcg.com/beyond-consulting/bcg-gamma/default`}>BCG</a>. Before that, I’ve had the privilege of working at <a href={`https://careers.google.com/`}>Google</a>, <a href={`https://www.bcgdv.com/`}>BCG Digital Ventures</a> and <a href={`https://www.pumpkin.care/`}>Pumpkin</a>. 
            I am usually optimistic, sometimes sensitive, and never giving up. 
            I love most things - including but not limited to - anime, gaming, coffee, arts, music, running, cosplaying,
            eating foods from around the world, learning new skills, connecting with people, self-reflection, and letting my mind wander.
            </p>
            </Intro>
            </Grid>
            </Grid>
          </Container>
        )
      }}
    />
  )
}

const Container = styled.div`
    position: relative;
    width: 65vw;
    min-width: 100%;
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
    transform: translateX(calc(50vw - 50%));
`

const Row = styled.div`
    display: flex;
    gap: 6rem;
`

const ProfilePic = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
`

// @media only screen and (max-width: 992px) {
//     height: 100%vw;
//     border-radius: 50%;
// }

const Intro = styled.div`
`

const aboutQuery = graphql`
  query AboutQuery {
    avatar: file(absolutePath: { regex: "/portrait.jpg/" }) {
      childImageSharp {
        fixed(height: 440, width: 300, quality: 100) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`

export default AboutMe
